export const DividerComponent = {
  bindings: {},
  transclude: true,
  templateUrl: 'components/Divider/divider/divider.html',
};
